import React from 'react';
import { T } from '@colonist/ui';
import { RUSH_RULES_YOUTUBE_VIDEO_URL } from '@colonist/consts';
import clsx from 'clsx';
import IconPassTurn from '@static/images/icon_pass_turn.svg';
import IconSettlementGold from '@static/images/settlement_gold.svg';
import IconDice4 from '@static/images/dice_4.svg';
import IconRobber from '@static/images/icon_robber.svg';
import styles from './UIGameRushIntro.module.scss';
const FACT_ROWS = [
    {
        icon: IconPassTurn,
        textKey: 'strings:popups.rushRules.fact1'
    },
    {
        icon: IconSettlementGold,
        textKey: 'strings:popups.rushRules.fact2'
    },
    {
        icon: IconDice4,
        textKey: 'strings:popups.rushRules.fact3'
    },
    {
        icon: IconRobber,
        textKey: 'strings:popups.rushRules.fact4'
    }
];
export const UIGameRushIntro = ({ backgroundColor })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.container, styles[backgroundColor])
    }, /*#__PURE__*/ React.createElement("ul", {
        className: styles.factList
    }, FACT_ROWS.map((row)=>/*#__PURE__*/ React.createElement("li", {
            key: row.textKey,
            className: styles.factItem
        }, /*#__PURE__*/ React.createElement("img", {
            className: styles.factIcon,
            src: row.icon
        }), /*#__PURE__*/ React.createElement("p", {
            className: styles.factText
        }, /*#__PURE__*/ React.createElement(T, {
            id: {
                key: row.textKey
            }
        }))))), /*#__PURE__*/ React.createElement("a", {
        className: styles.videoLink,
        href: RUSH_RULES_YOUTUBE_VIDEO_URL,
        target: "_blank",
        rel: "noopener noreferrer"
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.rushRules.watchVideoLink'
        }
    })));
};
